import React, { useCallback, useState } from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import FormCardGrid from '../../organisms/FormCardGrid';
import CustomFieldTable from '../../organisms/CustomFieldTable';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import Stepper from '../../organisms/Stepper';
import { SETTINGS_STEPS } from '../../../data/settingsSteps';

export default function FormFieldsStep({ stepMeta, stepperProps }) {
  const { state, update } = useSettingsWizard();
  const { formFields } = state;
  const [fieldToAdd, setFieldToAdd] = useState(null);
  const handleFieldsChange = useCallback((fields) => update({ formFields: fields }), [update]);

  return (
    <>
      <Stepper {...stepperProps} steps={SETTINGS_STEPS} />
      <SettingsCard
      title={stepMeta.title}
      description={stepMeta.description}
      showNext={false}
    >
      <div className="ca-form-fields">
        <CustomFieldTable onAddField={(field) => setFieldToAdd({ ...field })} />
        <FormCardGrid
          initialFields={formFields}
          fieldToAdd={fieldToAdd}
          onChange={handleFieldsChange}
        />
      </div>
      </SettingsCard>
    </>
  );
}
